// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.iwX2OrLHCU9ULn {
  color: var(--ds-text, #172b4d);
  font-size: 20px;
  font-weight: 600;
  letter-spacing: -0.008em;
  line-height: 24px;
  margin-top: 28px;
  display: block;
  text-align: center;
  margin-top: 64px;
  margin-bottom: 16px;
}
.JiwVp1ifBnRVap {
  color: var(--ds-text, #172b4d);
  display: block;
  text-align: center;
  font-size: 14px;
  line-height: 20px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headerMessage": `iwX2OrLHCU9ULn`,
	"secondaryMessage": `JiwVp1ifBnRVap`
};
export default ___CSS_LOADER_EXPORT___;
